var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GAME_RECEIVE_SINGLE_GAME_FROM_API, GENERAL_RECEIVE_GAMETEMPLATES, PLAYER_PURGE_ALL_DATA, GAME_PURGE_ALL_DATA, PLAYER_PURGE_ALL_PLAYER_INTERNAL_INFO, WEBSOCKET_MESSAGE, PLAYER_AUTHORIZATION_RECEIVE_TOKEN, } from 'components/constants';
import axios from 'axios';
import { websocketConnectAction } from './shared.actions';
import { userAuthLogoutRequestAction } from './userAuthorization.actions';
import { onboardingRequestNewPlayer } from '../../socketConnection/socketMessageRequests/onboardingRequests';
import { navigate } from 'helpers/navigation';
export var gameGetTemplatesAction = function (authToken) {
    var address = "".concat(window.globals.API_URL, "/templates");
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get(address, {
                            withCredentials: true,
                            headers: {
                                'User-Auth-Token': authToken
                            }
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch({
                        payload: data,
                        type: GENERAL_RECEIVE_GAMETEMPLATES,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    if (err_1.response && err_1.response.status === 403) {
                        dispatch(userAuthLogoutRequestAction());
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var gameJoinAction = function (token) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var joinMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: PLAYER_PURGE_ALL_PLAYER_INTERNAL_INFO,
                    });
                    return [4 /*yield*/, onboardingRequestNewPlayer(token)];
                case 1:
                    joinMessage = _a.sent();
                    dispatch({
                        type: WEBSOCKET_MESSAGE,
                        payload: joinMessage,
                    });
                    dispatch({
                        type: PLAYER_AUTHORIZATION_RECEIVE_TOKEN,
                        payload: token,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var gameCreateGameAction = function (templateID, name, datetime, authToken) {
    var address = "".concat(window.globals.API_URL, "/games");
    if (typeof datetime === 'string') {
        datetime = Number(datetime);
    }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, token, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, axios.post(address, { name: name, datetime: datetime, templateID: templateID }, {
                            withCredentials: true,
                            headers: {
                                'User-Auth-Token': authToken,
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    token = data ? data.token : '';
                    if (!token) return [3 /*break*/, 4];
                    dispatch({ type: GAME_PURGE_ALL_DATA });
                    dispatch({ type: PLAYER_PURGE_ALL_DATA });
                    dispatch({ type: GAME_RECEIVE_SINGLE_GAME_FROM_API, payload: data });
                    return [4 /*yield*/, dispatch(websocketConnectAction(data.token))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(gameJoinAction(data.token))];
                case 3:
                    _a.sent();
                    navigate('/facilitator');
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    if (err_2.response && err_2.response.status === 403) {
                        dispatch(userAuthLogoutRequestAction());
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
